export default __webpack_public_path__ + "static/media/ig-contained-icon.03b98119.svg";